module.exports = __webpack_public_path__ + "static/img/counselor－10.020344d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/counselor－10.jpg
// module id = /nfv
// module chunks = 1